"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[50355],{

/***/ 86599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ fetchPinnedGoals; },
/* harmony export */   "a": function() { return /* binding */ followGoal; }
/* harmony export */ });
/* harmony import */ var _api_fetchers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19982);
/* eslint-disable import/prefer-default-export */ 
var followGoal = function(goalUID, isFollow) {
    return (0,_api_fetchers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("v1/topology/users/".concat(goalUID, "/").concat(isFollow ? "pin" : "unpin", "/"), {
        requestType: "POST"
    });
};
var fetchPinnedGoals = function() {
    return (0,_api_fetchers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("v1/user/me/pinned_topology/?subscribed_goals=true&include_icons=true");
};


/***/ }),

/***/ 54839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);
/* harmony import */ var _auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85780);
/* harmony import */ var _selectors_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73060);





var useClassroomConsumption = function() {
    var shouldFetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var meUID = (0,_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_selectors_auth__WEBPACK_IMPORTED_MODULE_2__/* .getMeUid */ .Up);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(shouldFetch && meUID ? "v1/user/".concat(meUID, "/watch_time/progress/?is_limit_special_class_consumption_exp=True") : null), classroomConsumption = _ref.data, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, [
        "data"
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        classroomConsumption: classroomConsumption
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useClassroomConsumption);


/***/ }),

/***/ 87028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getDailyTimeLimit; },
/* harmony export */   "Q": function() { return /* binding */ getClassTimeConsumed; }
/* harmony export */ });
var getClassTimeConsumed = function(classesTimeConsumed) {
    return classesTimeConsumed ? classesTimeConsumed.dailyWatchLimit - classesTimeConsumed.todayWatchTime : null;
};
var getDailyTimeLimit = function(classesTimeConsumed) {
    return classesTimeConsumed ? classesTimeConsumed.dailyWatchLimit : null;
};


/***/ }),

/***/ 27300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52420);
/* harmony import */ var src_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89374);
/* harmony import */ var _context_IsPageInReduxContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9716);




var PageReduxProvider = function(param) {
    var children = param.children, initialReduxState = param.initialReduxState;
    var store = (0,src_redux__WEBPACK_IMPORTED_MODULE_1__/* .getStore */ .b)(initialReduxState);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_context_IsPageInReduxContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        store: store,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_redux__WEBPACK_IMPORTED_MODULE_0__/* .Provider */ .zt, {
            store: store,
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PageReduxProvider);


/***/ }),

/***/ 46907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$T": function() { return /* binding */ GET_SUBSCRIPTION; },
/* harmony export */   "$n": function() { return /* binding */ BOTTOMSHEET_VIEWED; },
/* harmony export */   "ED": function() { return /* binding */ BOTTOMSHEET_GOT_IT; },
/* harmony export */   "Qs": function() { return /* binding */ LIMITING_TIME_CONSUMPTION_GOALS; },
/* harmony export */   "ZV": function() { return /* binding */ BLOCKER_VIEWED; },
/* harmony export */   "ab": function() { return /* binding */ CLASS_BLOCKER_ID; },
/* harmony export */   "s3": function() { return /* binding */ LIMIT_EXHAUSTED; },
/* harmony export */   "ve": function() { return /* binding */ BLOCKER_DISMISSED; },
/* harmony export */   "xz": function() { return /* binding */ POST_CLASS_RECOMMENDATION_EXP; }
/* harmony export */ });
// segment
var BLOCKER_VIEWED = "Daily Limit - Blocker Viewed";
var BOTTOMSHEET_VIEWED = "Daily Limit - Bottom Sheet Viewed";
var BLOCKER_DISMISSED = "Daily Limit - CLX Blocker Dismissed";
var BOTTOMSHEET_GOT_IT = "Daily Limit - Got it Clicked";
var GET_SUBSCRIPTION = "Daily Limit - Get subscription clicked";
var LIMIT_EXHAUSTED = "Daily Limit - Limit Exhausted";
// list of goals for limiting class consumption
var LIMITING_TIME_CONSUMPTION_GOALS = [
    // prod goal uid
    "JAQRK",
    "QGFRK",
    "PZSIU",
    "NVLIA",
    // gammma goal uid
    "PESHE",
    "YAHCG",
    "WKOGR",
    "VIDUE",
    "JIWEO",
    "KSCGY",
    "TMUVD",
    "VLEMN",
    "YOTUH",
    "LVECA",
    "RTPSX",
    "ZIUBD",
    "GNFFE",
    "SDDOC",
    "TEWDQ",
    "IEIJT",
    "XTKHH",
    "RXRWJ",
    "TUNWK",
    "RJVOD",
    "PLWCX",
    "RUJGA",
    "BBKWG",
    "XNDUS",
    "QOIVT",
    "CKTCQ",
    "GWDPV",
    "ZYCWC",
    "DANNJ",
    "GSZGO",
    "JWBRG",
    "UQCMN",
    "BIZXQ",
    "SCTBY",
    "EJTZD",
    "TPSBK",
    "GWDPZ",
    "BDNTN",
    "XCTVJ",
    "ZISFF",
    "WKQWQ",
    "NYHNH",
    "QKHZF",
    "SCANJ",
    "QJEJG",
    "GMXMZ",
    "SUVLV",
    "MRZFY",
    "SIFWL",
    "FDGQK",
    "PPPOX",
    "KNMDN",
    "RYNDN",
    "FIYVI",
    "SASYW",
    "TICPI",
    "GUVHW",
    "EUDWC",
    "JUYYX",
    "BVHCS",
    "LFUWW",
    "TZNQX",
    "RJDNO",
    "XFOIT",
    "KVBFU",
    "CVGGX",
    "TNOJW",
    "WWKAS",
    "ZDYHU",
    "UMTAN",
    "LOPPY"
];
var CLASS_BLOCKER_ID = "CLASS_BLOCKER_ID";
var POST_CLASS_RECOMMENDATION_EXP = "web_post_class_recommendation_ab";


/***/ }),

/***/ 36578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59148);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);




var initial = {
    isPlayerLoaded: false,
    currentClassData: {},
    isClassPage: false
};
var getHandlers = function(set) {
    return {
        setPlayerLoaded: function() {
            var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            return set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, state), {
                    isPlayerLoaded: value
                });
            });
        },
        setCurrentClassData: function(data) {
            return set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, state), {
                    currentClassData: data
                });
            });
        },
        setIsClassPage: function() {
            var flag = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            return set(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, state), {
                    isClassPage: flag
                });
            });
        }
    };
};
var store = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(set) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, initial, getHandlers(set));
});
var useStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(store);
var usePlayerStore = function() {
    var currentClassData = useStore(function(state) {
        return state.currentClassData;
    });
    var isPlayerLoaded = useStore(function(state) {
        return state.isPlayerLoaded;
    });
    var isClassPage = useStore(function(state) {
        return state.isClassPage;
    });
    var setCurrentClassData = useStore(function(state) {
        return state.setCurrentClassData;
    });
    var setPlayerLoaded = useStore(function(state) {
        return state.setPlayerLoaded;
    });
    var setIsClassPage = useStore(function(state) {
        return state.setIsClassPage;
    });
    return {
        isPlayerLoaded: isPlayerLoaded,
        currentClassData: currentClassData,
        setCurrentClassData: setCurrentClassData,
        setPlayerLoaded: setPlayerLoaded,
        setIsClassPage: setIsClassPage,
        isClassPage: isClassPage
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePlayerStore);


/***/ }),

/***/ 29673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ blueDotFeature; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var blueDotFeature = {
    DOUBTS: 4
};


/***/ }),

/***/ 85399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ LoginModalLocalInfoContextProvider; },
/* harmony export */   "y": function() { return /* binding */ LoginModalLocalInfo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var LoginModalLocalInfoContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
var LoginModalLocalInfoContextProvider = LoginModalLocalInfoContext.Provider;
var LoginModalLocalInfo = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(LoginModalLocalInfoContext);
};


/***/ }),

/***/ 51320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);


var AppContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e1m9w4060",
    label: "AppContainer"
})("width:", _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.APP_CONTAINER_WIDTH */ .t8.MS, ";margin:auto;display:grid;grid-template-columns:repeat(24,1fr);grid-column-gap:16px;grid-row-gap:16px;min-height:", function(param) {
    var $isFooterHidden = param.$isFooterHidden;
    return " calc(\n    100vh -\n      ".concat(_styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_HEADER */ .t8.bu + _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_HEADER_MARGIN */ .t8.Cj + ($isFooterHidden ? 0 : _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_FOOTER */ .t8.SV + _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_FOOTER_MARGIN */ .t8.lK + 12), "px\n  )");
}, ";@media (max-width:70.95em){width:", function(param) {
    var $tabletWidth = param.$tabletWidth;
    return $tabletWidth || "1136px";
}, ";grid-template-columns:repeat(24,1fr);}");
/* harmony default export */ __webpack_exports__["Z"] = (AppContainer);


/***/ }),

/***/ 17359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);

var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e4w0nax0",
    label: "Container"
})("min-height:100vh;background-color:", function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor || "var(--color-base-0)";
}, ";min-width:100%;position:relative;");
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 79707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);

var Content = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eb5yt830",
    label: "Content"
})("display:grid;grid-column:1 / 25;grid-template-columns:repeat(24,32px);grid-column-gap:16px;grid-auto-rows:max-content;grid-row-gap:16px;@media (max-width:70.95em){grid-template-columns:repeat(24,1fr);grid-column-gap:8px;}");
/* harmony default export */ __webpack_exports__["Z"] = (Content);


/***/ }),

/***/ 73219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47426);
/* harmony import */ var _base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15509);
/* harmony import */ var _cont_Login_Login__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84079);
/* harmony import */ var _cont_ClassVideoPlayer_ClassVideoPlayer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86181);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2080);
/* harmony import */ var _base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28066);
/* harmony import */ var _stores_toggleables__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85690);
/* harmony import */ var _constants_toggleables__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(28119);
/* harmony import */ var _stores_AppCommonData__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83995);
/* harmony import */ var _Header_Header__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32078);
/* harmony import */ var _Components_Content__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(79707);
/* harmony import */ var _Components_AppContainer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51320);
/* harmony import */ var _Footer_BaseFooter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56015);
/* harmony import */ var _Components_Container__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(17359);


















var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Components_Container__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
    target: "eeymnxw0",
    label: "Container"
})("@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.tablet */ .AV.tablet, "){min-width:0px;}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.mobile */ .AV.mobile, "){width:100vw;}");
var NavbarWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "eeymnxw1",
    label: "NavbarWrapper"
})("position:relative;grid-column:1/7;z-index:2;height:100%;@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.mobile */ .AV.mobile, "){display:none;}");
var HelpCenterNavBar = (0,_base_Dynamic_Dynamic__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
    return __webpack_require__.e(/* import() */ 89118).then(__webpack_require__.bind(__webpack_require__, 89118));
});
var AppContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Components_AppContainer__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    target: "eeymnxw2",
    label: "AppContainer"
})("margin-top:0;@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.tablet */ .AV.tablet, "){width:100%;}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.mobile */ .AV.mobile, "){display:grid;grid-column-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";grid-row-gap:0;grid-template-columns:repeat(10,1fr);}");
var Content = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Components_Content__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
    target: "eeymnxw3",
    label: "Content"
})("margin-top:", function(param) {
    var fullHeight = param.fullHeight;
    return fullHeight ? "0" : "40px";
}, ";grid-column:", function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 1 : 7;
}, " / 25;grid-template-columns:repeat(\n    ", function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 24 : 18;
}, ",32px\n  );", function(param) {
    var position = param.position;
    return position ? "position: ".concat(position, ";") : "";
}, "  @media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.tablet */ .AV.tablet, "){margin:auto;width:100%;grid-template-columns:repeat(\n      ", function(param) {
    var fullWidth = param.fullWidth;
    return fullWidth ? 24 : 18;
}, ",1fr\n    );}@media only screen and (max-width:728px){grid-template-columns:none;width:100%;}@media only screen and (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.mobile */ .AV.mobile, "){grid-column:span 10;grid-row-gap:0;grid-column-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";display:block;padding:0 ", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_4B */ .t8.BM, ";}");
var StyledDrawer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Drawer_Drawer__WEBPACK_IMPORTED_MODULE_4__["default"], {
    target: "eeymnxw4",
    label: "StyledDrawer"
})("&.MuiDrawer-root > .MuiPaper-root{grid-template-rows:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_15B */ .t8.F9, " 1fr;}");
var HelpCenterLayout = function(param) {
    var children = param.children, _layoutOptions = param.layoutOptions, layoutOptions = _layoutOptions === void 0 ? {} : _layoutOptions;
    var renderLogin = function renderLogin() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(StyledDrawer, {
            login: true,
            drawerState: showLoginDrawer,
            onClose: onClose,
            showBackButton: backButton.value,
            hideCloseButton: backButton.value,
            onPressBack: handleBackPress,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_cont_Login_Login__WEBPACK_IMPORTED_MODULE_5__["default"], {
                setBackButton: setBackButton,
                backButton: backButton
            })
        });
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var route = router.route, query = router.query;
    var ref = (0,_stores_toggleables__WEBPACK_IMPORTED_MODULE_9__/* .useToggleable */ .F7)(_constants_toggleables__WEBPACK_IMPORTED_MODULE_17__/* .LOGIN_DRAWER */ .es), showLoginDrawer = ref.isOpen, closeLoginDrawer = ref.closeElement;
    var isMobile = (0,_stores_AppCommonData__WEBPACK_IMPORTED_MODULE_10__/* .useIsMobile */ .dD)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        value: false,
        fn: function() {}
    }), backButton = ref1[0], setBackButton = ref1[1];
    var handleBackPress = function() {
        backButton.fn();
    };
    /**
   * To check whether it is called from domain other than unacademy
   */ var isExternal = (query === null || query === void 0 ? void 0 : query.external) === "1";
    var _isCheckoutUrl = layoutOptions.isCheckoutUrl, isCheckoutUrl = _isCheckoutUrl === void 0 ? false : _isCheckoutUrl, _hideFooter = layoutOptions.hideFooter, hideFooter = _hideFooter === void 0 ? false : _hideFooter, _hideHeader = layoutOptions.hideHeader, hideHeader = _hideHeader === void 0 ? false : _hideHeader;
    var showHelpCenterNavbar = route.indexOf("/helpcenter/category/[categoryID]") > -1;
    var onClose = function() {
        closeLoginDrawer();
    };
    var insideApp = query.inside_app === "true" || false;
    var backgroundColor = _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .legalPageRoutes.includes */ .T3.includes(route) ? "var(--color-base-0)" : null;
    var tabletWidth = _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .tabletRoutes.includes */ .VK.includes(route) ? "728px" : "1136px";
    var showClassPlayer = isExternal ? true : !isMobile;
    if (isExternal) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsxs */ .BX)(Container, {
            backgroundColor: "var(--color-i-black-9)",
            children: [
                children,
                showClassPlayer && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_cont_ClassVideoPlayer_ClassVideoPlayer__WEBPACK_IMPORTED_MODULE_6__["default"], {})
            ]
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsxs */ .BX)(Container, {
        backgroundColor: backgroundColor,
        children: [
            !insideApp && !hideHeader && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_Header_Header__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                isCheckoutUrl: isCheckoutUrl
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsxs */ .BX)(AppContainer, {
                backgroundColor: backgroundColor,
                $tabletWidth: tabletWidth,
                $isFooterHidden: hideFooter,
                children: [
                    showHelpCenterNavbar && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(NavbarWrapper, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(HelpCenterNavBar, {})
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(Content, {
                        fullWidth: !showHelpCenterNavbar,
                        children: children
                    }),
                    showClassPlayer && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_cont_ClassVideoPlayer_ClassVideoPlayer__WEBPACK_IMPORTED_MODULE_6__["default"], {})
                ]
            }),
            !insideApp && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_Footer_BaseFooter__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                display: !hideFooter,
                noFooter: hideFooter
            }),
            renderLogin()
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HelpCenterLayout);


/***/ }),

/***/ 48643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ni": function() { return /* binding */ fetchTickets; },
/* harmony export */   "Zt": function() { return /* binding */ fetchArticles; },
/* harmony export */   "a3": function() { return /* binding */ fetchArticleInfo; },
/* harmony export */   "co": function() { return /* binding */ onChatOpen; },
/* harmony export */   "fA": function() { return /* binding */ sendFeedback; },
/* harmony export */   "pE": function() { return /* binding */ fetchCategories; }
/* harmony export */ });
/* harmony import */ var _utils_paginateAction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72894);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94336);
/* harmony import */ var _schemas__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93010);



var freshbotCdnUrl = "https://support-bot-cdn.uacdn.net/";
var freshbotUrl = "https://support-bot.unacademy.com/";
var onChatOpen = function() {
    var role = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "learner";
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .helpCenterTypes.ON_CHAT_OPEN */ .gC.ON_CHAT_OPEN,
            endpoint: "".concat(freshbotUrl, "history/on_open"),
            method: "put",
            useJWTToken: true,
            data: {
                role: role
            }
        });
    };
};
var fetchCategories = function(param) {
    var goalUid = param.goalUid, _portal = param.portal, portal = _portal === void 0 ? "plus" : _portal;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .helpCenterTypes.FETCH_CATEGORIES */ .gC.FETCH_CATEGORIES,
            endpoint: "".concat(freshbotCdnUrl, "freshdesk/v1/categories?goal=").concat(goalUid, "&portal=").concat(portal),
            method: "get"
        });
    };
};
var getArticles = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .helpCenterTypes.FETCH_ARTICLES */ .gC.FETCH_ARTICLES,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_1__/* .paginatorListSchema */ .EH
        };
    };
};
var fetchArticles = function(param) {
    var goalUid = param.goalUid, categoryID = param.categoryID, _portal = param.portal, portal = _portal === void 0 ? "plus" : _portal, _nextPage = param.nextPage, nextPage = _nextPage === void 0 ? false : _nextPage, _resetWithoutEmpty = param.resetWithoutEmpty, resetWithoutEmpty = _resetWithoutEmpty === void 0 ? false : _resetWithoutEmpty;
    var resultKey = "".concat(goalUid, "-").concat(categoryID, "-").concat(portal);
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("".concat(freshbotCdnUrl, "freshdesk/v1/categories/").concat(categoryID, "/articles?goal=").concat(goalUid, "&portal=").concat(portal), getArticles(resultKey, resetWithoutEmpty), "articleFeed", resultKey, resetWithoutEmpty)(nextPage);
};
var getTickets = function(key, jwtToken, param, resetWithoutEmpty) {
    var role = param.role;
    return function(next) {
        var url = next;
        try {
            var absUrl = new URL(next);
            absUrl.searchParams.append("role", role);
            url = absUrl.href;
        } catch (err) {
            url = next;
        }
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .helpCenterTypes.FETCH_TICKETS_HISTORY */ .gC.FETCH_TICKETS_HISTORY,
            endpoint: url,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_1__/* .paginatorListSchema */ .EH,
            headers: {
                authorization: "Bearer ".concat(jwtToken)
            }
        };
    };
};
var fetchTickets = function(param) {
    var _portal = param.portal, portal = _portal === void 0 ? "plus" : _portal, _nextPage = param.nextPage, nextPage = _nextPage === void 0 ? false : _nextPage, _resetWithoutEmpty = param.resetWithoutEmpty, resetWithoutEmpty = _resetWithoutEmpty === void 0 ? false : _resetWithoutEmpty, _jwtToken = param.jwtToken, jwtToken = _jwtToken === void 0 ? "" : _jwtToken, _role = param.role, role = _role === void 0 ? "learner" : _role;
    var resultKey = "".concat(portal, "-history");
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("".concat(freshbotUrl, "history/tickets?per_page=3"), getTickets(resultKey, jwtToken, {
        role: role
    }, resetWithoutEmpty), "tickets", resultKey, resetWithoutEmpty)(nextPage);
};
var fetchArticleInfo = function(param) {
    var articleID = param.articleID;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .helpCenterTypes.FETCH_ARTICLE_INFO */ .gC.FETCH_ARTICLE_INFO,
            endpoint: "".concat(freshbotCdnUrl, "freshdesk/v1/articles/").concat(articleID),
            method: "get"
        });
    };
};
var sendFeedback = function(param) {
    var articleID = param.articleID, positiveFeedback = param.positiveFeedback;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_0__/* .helpCenterTypes.FETCH_ARTICLE_INFO */ .gC.FETCH_ARTICLE_INFO,
            endpoint: "".concat(freshbotUrl, "freshdesk/v1/articles/").concat(articleID, "/feedback"),
            method: "post",
            data: {
                positive_feedback: positiveFeedback
            }
        });
    };
};


/***/ }),

/***/ 41721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export playerReferralDialogStore */
/* harmony import */ var zustand_vanilla__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59148);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var _utils_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18113);
/* harmony import */ var _utils_localStorage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77090);




var getLocalStorageItem = function(key) {
    if ((0,_utils_localStorage__WEBPACK_IMPORTED_MODULE_1__/* .localStorageAvailable */ .V)()) {
        return localStorage.getItem(key);
    }
};
var playerReferralDialogStore = (0,zustand_vanilla__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(set) {
    return {
        showReferralDialog: false,
        setShowReferralDialog: function(classUID) {
            return set(function() {
                var showDialog = !(0,_utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* .readCookie */ .vQ)("referral-player") || Math.round((new Date() - new Date(Number((0,_utils_cookies__WEBPACK_IMPORTED_MODULE_0__/* .readCookie */ .vQ)("referral-player")))) / (1000 * 3600 * 24)) > 7;
                return {
                    showReferralDialog: classUID ? getLocalStorageItem("liveSessions[".concat(classUID.current, "]")) > 1800 && showDialog : null
                };
            });
        }
    };
});
var usePlayerReferralDialogStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(playerReferralDialogStore);
/* harmony default export */ __webpack_exports__["Z"] = (usePlayerReferralDialogStore);


/***/ }),

/***/ 78758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getExperimentVariation; }
/* harmony export */ });
/* unused harmony export getExperimentVariationSetter */
/* eslint-disable import/prefer-default-export */ var getExperimentVariation = function(experimentName) {
    return function(state) {
        return state.experimentVariations[experimentName] || null;
    };
};
var getExperimentVariationSetter = function(state) {
    return state.setExperimentVariations;
};


/***/ }),

/***/ 76205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getShowReferralDialog; },
/* harmony export */   "z": function() { return /* binding */ getSetShowReferralDialog; }
/* harmony export */ });
var getShowReferralDialog = function(param) {
    var showReferralDialog = param.showReferralDialog;
    return showReferralDialog;
};
var getSetShowReferralDialog = function(param) {
    var setShowReferralDialog = param.setShowReferralDialog;
    return setShowReferralDialog;
};


/***/ }),

/***/ 97580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ validateRedirectURL; }
/* harmony export */ });
function validateRedirectURL(redirectTo) {
    return (redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.startsWith("/")) && !(redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.includes("/\\")) && !(redirectTo === null || redirectTo === void 0 ? void 0 : redirectTo.startsWith("//")) && !/^\/[\s]{1}/.test(redirectTo) ? redirectTo : false;
};


/***/ }),

/***/ 21192:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var whiteListed = [
    "/combat",
    "/event",
    "/prodigy",
    "/pitch-assist"
];
var checkWhiteListed = function(router) {
    var redirectUrl = router.query.redirect;
    if (!redirectUrl) return null;
    for(var i = 0; i < whiteListed.length; i += 1){
        if (redirectUrl.startsWith(whiteListed[i])) return redirectUrl;
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (checkWhiteListed);


/***/ })

}]);